import { j as e } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { BoxShadows as i } from "../../1-foundations/BoxShadows/BoxShadows.js";
import { Colors as s } from "../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import "../../../FeatureFlagProvider-DyczYY1y.js";
import "react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function l(t) {
  const {
    children: d,
    onClick: o,
    hasNoBorderRadius: n,
    borderColor: r
  } = t;
  return /* @__PURE__ */ e(o ? "button" : "div", {
    css: {
      width: "100%",
      backgroundColor: s.white200,
      padding: 16,
      borderRadius: n ? void 0 : 8,
      transition: "box-shadow 200ms ease",
      boxShadow: o ? i.interactive : void 0,
      ":hover": {
        boxShadow: o ? i.hover : void 0,
        cursor: o ? "pointer" : void 0
      },
      border: r ? `1px solid ${r}` : "none"
    },
    onClick: o,
    children: d
  });
}
export {
  l as Card
};
